/**
 *
 * Company
 *
 */
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  generatePath,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom';
import { RouteConstants } from '../../routes';
import { selectPermissions } from '../Authorization/slice/selectors';
import CompanyDetails from './pages/CompanyDetails/CompanyDetails';
import CompanyList from './pages/CompanyList/CompanyList';
import CompanyForm from './parts/CompanyForm/CompanyForm';
import CompanyShareForm from './parts/CompanyShareForm/CompanyShareForm';

interface IProps extends RouteComponentProps {}

export function Company(props: IProps) {
  const { companyAdministration } = useSelector(selectPermissions);
  if (companyAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <>
      <Switch>
        <Route path={RouteConstants.company.list} component={CompanyList} />
        <Route
          path={RouteConstants.company.details}
          component={CompanyDetails}
        />
        <Route
          exact
          path={RouteConstants.company.index}
          render={props => (
            <Redirect
              to={generatePath(RouteConstants.company.list, {
                envId: Number(props.match.params.envId),
              })}
            />
          )}
        />
      </Switch>
      <CompanyShareForm />
      <CompanyForm />
    </>
  );
}
